/*
import { useSelector, useDispatch } from 'react-redux';
import { updateMessage,updateMessage2} from '../store/slice';

const message = useSelector((state:any) => state.message);
const dispatch = useDispatch();

dispatch(updateMessage("Hi.Mani.Saro.."));
console.log("message:",message);
*/
import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    editUserInfo: [],
    editPaymentInfo: [],
    ecompay: [],
    getBodyData: {},
    getPlanInfo: [],
    getCcassPlanInfo: [],
    getPlanPageOpen: [],
    getPlanPageOpenCCass: [],
    getDataEnterFromAddCardUpdate: {},
    getDataEnterFromAddCardUpdateNumber: {},
    profile_photo: {},
    nameValue: {},
    didnumber: {},
    licensetotValue: {},
    resetURL: "",
    paymentBotData:{},
  },
  reducers: {
    setEditUserInfo: (state, action) => {
      state.editUserInfo = action.payload;
      console.log("action.payload", action.payload);
    },
    setEditPaymentInfo: (state, action) => {
      state.editPaymentInfo = action.payload;
    },
    setEcompay: (state, action) => {
      state.ecompay = action.payload;
    },
    setBodyData: (state, action) => {
      state.getBodyData = action.payload;
    },
    setPlanInfo: (state, action) => {
      state.getPlanInfo = action.payload;
    },
    setCcassPlanInfo: (state, action) => {
      state.getCcassPlanInfo = action.payload;
    },
    setPlanPageOneInfo: (state, action) => {
      state.getPlanPageOpen = action.payload;
    },
    setPlanPageOneInfoCCass: (state, action) => {
      state.getPlanPageOpenCCass = action.payload;
    },
    setDataEnterFromAddCardUpdate: (state, action) => {
      state.getDataEnterFromAddCardUpdate = action.payload;
    },
    setDataEnterFromAddCardUpdateNumber: (state, action) => {
      state.getDataEnterFromAddCardUpdateNumber = action.payload;
    },
    setUserPhotoUpload: (state, action) => {
      state.profile_photo = action.payload;
    },
    setNameValue: (state, action) => {
      state.nameValue = action.payload;
    },
    setDidNumber: (state, action) => {
      state.didnumber = action.payload;
    },
    setLicenseTotValue: (state, action) => {
      state.licensetotValue = action.payload;
    },
    setResetURL: (state, action) => {
      state.resetURL = action.payload;
    },
    setPaymentBotData: (state, action) => {
      state.paymentBotData = action.payload;
    },
  },
});

export const {
  setEditUserInfo,
  setEditPaymentInfo,
  setEcompay,
  setBodyData,
  setPlanInfo,
  setCcassPlanInfo,
  setDataEnterFromAddCardUpdate,
  setDataEnterFromAddCardUpdateNumber,
  setPlanPageOneInfoCCass,
  setPlanPageOneInfo,
  setNameValue,
  setUserPhotoUpload,
  setDidNumber,
  setLicenseTotValue,
  setResetURL,
  setPaymentBotData
} = userSlice.actions;

export default userSlice.reducer;
